<template>
  <div class="page" v-cloak>

    <div class="top" v-if="isType == 1">
      <div class="icon">
        <van-icon name="checked" color="#00A8C0" />
      </div>
      <div class="mt20 title">您已完成兑换</div>
      <div class="mt10">如果有问题，请 <span class="contact" @click="makePhoneCall">联系我们</span></div>
    </div>
    <div class="top" v-else>
      <div class="icon">
        <van-icon name="clear" color="#C64545" />
      </div>
      <div class="mt20 title">兑换失败，请重试</div>
      <div class="mt10">如果有问题，请 <span class="contact" @click="makePhoneCall">联系我们</span></div>
    </div>

    <div class="btn-block" v-if="isType == 1">
      <div class="btn" @click="goIndex">返回首页</div>
      <div class="btn btns" @click="goOrder">查看订单</div>
    </div>

    <div class="btn-block" v-else>
      <div class="btn" @click="goIndex">返回首页</div>
      <div class="btn btns" @click="goCardexchange">重新兑换</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'exchangePayResult',
  components: {},
  props: {},
  data() {
    return {
      isType: this.$route.query.isType,
      aa: {}
    }
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue)
      },
      deep: true // 深度监听表单
    },
  },
  created() { },
  mounted() { },
  methods: {
    // 返回订单
    goOrder() {
      this.$router.push({
        name: 'order-list',
        query: {}
      });
    },
    // 跳首页
    goIndex() {
      this.$router.push({
        name: 'index',
        query: {}
      });
    },
    // 跳首页
    goCardexchange() {
      this.$router.push({
        name: 'exchange',
        query: {
          id: ''
        }
      });
    },
    makePhoneCall() {
       this.MakeCall() //拨打电话
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding-top: 150px;

  .top {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }

  .icon {
    width: 85px;
    height: 85px;
    /* background: papayawhip; */
    font-size: 85px;
    margin: 0 auto;
  }

  .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 30px;
    color: #2a2e43;
    letter-spacing: 2.5px;
  }

  .contact {
    color: #3497fd;
  }

  .btn-block {
    /* background-color: #eee; */
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 50px;
  }

  .btn {
    width: 130px;
    height: 100%;
    border: 1px solid #707070;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 5px;
  }

  .btns {
    border: 1px solid #03a8c0;
    color: #03a8c0;
  }
}
</style>
